import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titlecase'
})

export class TitlecasePipe implements PipeTransform {

  transform(value: string | null | undefined): string | null {
    if (!value) return null;
    const lowercased = value.toLowerCase();
    const words = lowercased.split(' ');
    words[0] = words[0][0].toUpperCase() + words[0].slice(1);
    return words.join(' ');
  }
}
